/**
 * Judge.me preview badge on the product page: show "4,8 (2)" next to the stars instead of
 * "2 reviews". Judge.me renders the badge server-side and may re-render it on load, so the
 * widget is watched and reformatted whenever its content changes.
 */
const WIDGET_SELECTOR = '#main-product .jdgm-preview-badge';

function formatBadge(badge) {
  const text = badge.querySelector('.jdgm-prev-badge__text');
  const average = parseFloat(badge.dataset.averageRating);
  const count = parseInt(badge.dataset.numberOfReviews, 10);
  if (!text || Number.isNaN(average) || Number.isNaN(count) || count === 0) return;

  const averageLabel = average.toFixed(1).replace('.', ',');
  const countLabel = `(${count})`;

  // Judge.me replaces the text content again after load (e.g. translating "reviews"),
  // which drops our spans, so check the live markup rather than a flag.
  const currentAverage = text.querySelector('.bx-rating__avg');
  const currentCount = text.querySelector('.bx-rating__count');
  if (
    currentAverage &&
    currentCount &&
    currentAverage.textContent === averageLabel &&
    currentCount.textContent === countLabel
  ) {
    return;
  }

  const averageEl = document.createElement('span');
  averageEl.className = 'bx-rating__avg';
  averageEl.textContent = averageLabel;

  const countEl = document.createElement('span');
  countEl.className = 'bx-rating__count';
  countEl.textContent = countLabel;

  text.replaceChildren(averageEl, ' ', countEl);
}

function formatWidget(widget) {
  widget.querySelectorAll('.jdgm-prev-badge').forEach(formatBadge);
}

export function initJudgemeBadge(root = document) {
  root.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
    if (widget.dataset.bxBadge) return;
    widget.dataset.bxBadge = '1';
    formatWidget(widget);
    new MutationObserver(() => formatWidget(widget)).observe(widget, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  });
}
